let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4enD4")).then(() => parcelRequire('cJxeY'));